module.exports = __webpack_public_path__ + "static/media/stopp.d31567e0.png";